import { components } from '@api/club/generated';
import { proxy } from 'valtio';

import { getPresentRounds } from '@features/tournament/utils/tournamentHelpers';

export class TournamentState {
  constructor(
    public clubId: string,
    public tournamentId: string,
  ) {}

  isLoading: boolean = true;
  isUpdating: boolean = false;

  private _tournament?: components['schemas']['UserTournamentDto'];

  get tournament() {
    return this._tournament;
  }

  set tournament(t: components['schemas']['UserTournamentDto'] | undefined) {
    const prevSelected = this.selectedRound;
    const prevLast = this.lastRound;

    this._tournament = t;
    this.visibleRounds = getPresentRounds(t?.rounds);
    this.lastRound = this.visibleRounds?.[this.visibleRounds.length - 1];

    if (prevLast === prevSelected) {
      this.selectedRound = this.lastRound;
    }
  }

  visibleRounds?: components['schemas']['RoundDto'][];
  lastRound?: components['schemas']['RoundDto'];
  selectedRound?: components['schemas']['RoundDto'];
}

export class TournamentStore {
  constructor(
    clubId: string,
    tournamentId: string,
    private onRefetch: () => void,
  ) {
    this.state = proxy(new TournamentState(clubId, tournamentId));
  }

  state: TournamentState;

  refetch = () => this.onRefetch();
  selectRound = (num: number) => {
    this.state.selectedRound = this.state.visibleRounds?.find((r) => r.roundNumber === num);
  };
}
